var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckedDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 0H1.66667C0.7462 0 0 0.7462 0 1.66667V18.3333C0 19.2538 0.7462 20 1.66667 20H18.3333C19.2538 20 20 19.2538 20 18.3333V1.66667C20 0.7462 19.2538 0 18.3333 0ZM1.66667 18.3333V1.66667H18.3333V18.3333H1.66667Z",
    fill: "#3D3C42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3333 1.66667H1.66667V18.3333H18.3333V1.66667Z",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 14.5833L4.16667 10.45L5.49167 9.16667L8.33333 11.9583L14.5083 5.83333L15.8333 7.15L8.33333 14.5833Z",
    fill: "#3D3C42"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_17"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedDefault);
export default __webpack_public_path__ + "static/media/checked_default.7b427a0d08cbfe95385f6552920c8a77.svg";
export { ForwardRef as ReactComponent };